/* eslint-disable */
import jQuery from 'jquery'
import 'jquery-form'
import Application from '../application'
export default {
    FormSubmit(compName, Model, ID) {
        return {
            name: compName,
            data() {
                return this.$form.initializeData(Model)
            },
            created() {
                this.$form.modeSetup()
                this.$form.requestSetup()
            },
            //mounted() {
            //    this.peformFormSetup()
            //},
            methods: {
                submit() {
                    var instance = this
                    if (instance.$refs.form.validate()) {
                        instance.$Progress.start()
                        jQuery('#input-form').ajaxSubmit({
                            url: Application.BaseUrl + jQuery('#input-form').attr('action'),
                            xhrFields: {
                                withCredentials: true
                            },
                            success: function (data, status, jqxhr, $form) {
                                instance.$Progress.finish()
                                instance.complete({ data, status, jqxhr, $form })
                            },
                            error: function (jqxhr, status, error) {
                                instance.$Progress.fail()
                                instance.complete({ jqxhr, status, error })
                            },
                            uploadProgress: function (position, total, percentComplete) {
                                instance.$Progress.set(percentComplete / total * 100)
                            }
                        })
                    }
                },
                // Override
                complete(params) {

                },
                reset() {
                    this.$refs.form.reset()
                }
                //,
                //peformFormSetup() {
                //    var instance = this
                //    instance.$form.setup(ID).then(function () {
                //        localStorage.removeItem('data')
                //    })
                //}
            }
        }
    },
    Crud(compName, Model, ID, getRecordUrl, deleteRecordUrl) {
        return {
            name: compName,
            data() {
                return this.$form.initializeData(Model)
            },
            created() {
                this.$form.modeSetup()
                this.$form.requestSetup()
            },
            mounted() {
                //this.peformFormSetup()
            },
            methods: {
                submit() {
                    var instance = this
                    if (instance.$refs.form.validate()) {
                        instance.$form.submitConfirmAction('#input-form').then(function (params) {
                            instance.$form.saveSuccess(params).then(function (status) {
                                if (status) {
                                    instance.$root.$dialog('Información', '¡El registro se guardó exitosamente!')
                                        .then(status => {
                                            instance.reset()
                                        })
                                } else {
                                    instance.$root.$dialog('Error', '¡Ocurrió un error al intentar guardar el registro!')
                                        .then(status => {

                                        })
                                }
                            }).catch((status) => {
                                instance.$root.$dialog('Error', '¡Ocurrió un error al intentar guardar el registro!')
                                    .then(status => {

                                    })
                            })
                        }).catch((params) => {
                            params.error = (typeof params.error !== 'undefined') ? '<br>Tipo de Error: ' + params.error : '';
                            var responseText = (params.jqxhr.responseText !== '') ? '<br>Mensaje de Error: ' + params.jqxhr.responseText : '';
                            instance.$root.$dialog('Error', '¡Ocurrió un error al procesar la solicitud!. ' + params.error + ': ' + responseText)
                                .then(status => {
                                    instance.reset()
                                })
                        })
                    }
                },
                reset() {
                    this.$refs.form.reset()
                    this.formDialog = false
                },
                close() {
                    this.reset()
                },
                //peformFormSetup() {
                //    var instance = this
                //    instance.$form.setup(ID).then(function () {
                //        instance.formDialog = false
                //    })
                //},
                search() {
                    var instance = this
                    instance.loading = true
                    instance.$form.submit('#search-form').then(function (params) {
                        instance.$form.searchSuccess(params).then(function (params) {
                            instance.rows = params.data
                            instance.$Progress.finish()
                            instance.loading = false
                            if (params.data.length === 0) {
                                instance.$root.$snackbar('¡No se han encontrado registros con sus criterios de búsqueda!', { color: 'info' })
                            }
                        }).catch(function (status) {
                            instance.$Progress.fail()
                            instance.loading = false
                        })
                    }).catch((params) => {
                        instance.$Progress.finish()
                        instance.loading = false
                        params.error = (typeof params.error !== 'undefined') ? '<br>Tipo de Error: ' + params.error : ''
                        var responseText = (params.jqxhr.responseText !== '') ? '<br>Mensaje de Error: ' + params.jqxhr.responseText : ''
                        instance.$root.$snackbar('¡Ocurrió un error al procesar la solicitud! ' + params.error + ': ' + responseText, { color: 'error' })
                    })
                },
                bindRecordToForm(record) {
                    var self = this
                    for (var i = 0; i < self.formInputs.length; i++) {
                        self.formInputs[i].model = record[self.formInputs[i].name]
                    }
                    this.formDialog = true
                    //console.log("Termine el bind")
                    //this.performFormSetup()
                },
                view(Id, $event) {
                    var instance = this
                    instance.formMode = 'ReadOnly'
                    instance.$grid.getRecord(getRecordUrl, { Id: Id }, $event)
                        .then(params => {
                            if (params.data.constructor === Array) {
                                instance.bindRecordToForm(params.data[0])
                            } else {
                                instance.bindRecordToForm(params.data)
                            }
                        }).catch(instance.$ajax.error)
                },
                edit(Id, $event) {
                    var instance = this
                    instance.formMode = 'Update'
                    instance.$grid.getRecord(getRecordUrl, { Id: Id }, $event)
                        .then(params => {
                            if (params.data.constructor === Array) {
                                instance.bindRecordToForm(params.data[0])
                            } else {
                                instance.bindRecordToForm(params.data)
                            }
                        }).catch(instance.$ajax.error)
                },
                copy(Id, $event) {
                    var instance = this
                    instance.formMode = 'Add'
                    instance.$grid.getRecord(getRecordUrl, { Id: Id }, $event)
                        .then(params => {
                            if (params.data.constructor === Array) {
                                instance.bindRecordToForm(params.data[0])
                            } else {
                                instance.bindRecordToForm(params.data)
                            }
                        }).catch(instance.$ajax.error)
                },
                del(Id, $event, index) {
                    var instance = this
                    instance.$grid.deleteRecord(deleteRecordUrl, { Id: Id }, $event, index)
                        .then(instance.$grid.deleteRecordSuccess)
                        .catch(params => {
                            instance.$ajax.error(params)
                        })
                }
            }
        }
    },
    install(Vue, options) {
        Vue.mixin({
            beforeCreate() {
                var instance = this
                this.$form = {
                    getSelectValue(element) {
                        return Array.from(element).map((el) => el.value);
                    },
                    submit(el) {
                        return new Promise(function (resolve, reject) {
                            instance.$Progress.start()
                            jQuery(el).ajaxSubmit({
                                url: Application.BaseUrl + jQuery(el).attr('action'),
                                crossDomain: true,
                                success: function (data, status, jqxhr, $form) {
                                    instance.$Progress.finish()
                                    resolve({ data, status, jqxhr, $form })
                                },
                                error: function (jqxhr, status, error) {
                                    instance.$Progress.fail()
                                    reject({ jqxhr, status, error })
                                },
                                uploadProgress: function (position, total, percentComplete) {
                                    instance.$Progress.set(percentComplete / total * 100)
                                }
                            })
                        })
                    },
                    submitConfirmAction(el, message) {
                        if (typeof message === 'undefined') message = 'Por favor confirme la acción solicitada. ¿Está seguro que quieres hacer esto?'
                        return new Promise(function (resolve, reject) {
                            instance.$root.$confirm('confirme', message).then(confirm => {
                                if (confirm) {
                                    instance.$Progress.start()
                                    jQuery(el).ajaxSubmit({
                                        url: Application.BaseUrl + jQuery(el).attr('action'),
                                        crossDomain: true,
                                        success: function (data, status, jqxhr, $form) {
                                            instance.$Progress.finish()
                                            resolve({ data, status, jqxhr, $form })
                                        },
                                        error: function (jqxhr, status, error) {
                                            instance.$Progress.fail()
                                            reject({ jqxhr, status, error })
                                        },
                                        uploadProgress: function (position, total, percentComplete) {
                                            instance.$Progress.set(percentComplete / total * 100)
                                        }
                                    })
                                }
                            })
                        })
                    },
                    saveSuccess(params) {
                        var instance = this
                        return new Promise(function (resolve, reject) {
                            if (params.data === 'ERROR') { resolve(false) } else if (params.data === 'OK') { resolve(true) } else if (params.data === '') {
                                instance.$root.$snackbar('¡La respuesta del servidor estaba vacía!', { color: 'error' })
                            } else {
                                instance.$root.$snackbar('¡Ocurrió un error desconocido en la solicitud!', { color: 'error' })
                            }
                        })
                    },
                    searchSuccess(params) {
                        return new Promise(function (resolve, reject) {
                            if (params.data.constructor === Array) {
                                resolve(params)
                            } else {
                                reject(params)
                            }
                        })
                    },
                    requestSetup() {
                        jQuery.ajaxSetup({
                            statusCode: {
                                401(xhr) {
                                    instance.$router.replace(Application.onLoggedOutRedirectTo)
                                },
                                403(xhr) {
                                    instance.$root.$snackbar('No tienes suficientes credenciales para acceder al recurso.', { color: 'error' })
                                },
                                404(xhr) {
                                    instance.$root.$snackbar('El recurso al que estás intentando acceder no pudo ser encontrado.', { color: 'error' })
                                }
                            }
                        })
                    },
                    modeSetup() {
                        return new Promise(function (resolve, reject) {
                            if (localStorage.getItem('formMode') === null) {
                                instance.formMode = 'Add'
                            } else {
                                instance.formMode = localStorage.getItem('formMode')
                                localStorage.removeItem('formMode')
                            }
                            resolve()
                        })
                    },
                    //setup(ID) {
                    //    return new Promise(function (resolve, reject) {
                    //        if (typeof ID === 'undefined' || ID === '' || ID === null) { resolve() } else if (ID.constructor === Array) {
                    //            for (var i = 0; i < ID.length; i++) {
                    //                var element1 = document.getElementById(ID[i])
                    //                if (!element1) continue
                    //                if (instance.formMode === 'Update') {
                    //                    if (element1.nodeName === 'SELECT') {
                    //                        element1.setAttribute('disabled', true)
                    //                        var input1 = document.createElement('input')
                    //                        input1.name = element1.name
                    //                        input1.type = 'hidden'
                    //                        input1.value = JSON.parse(localStorage.getItem('data'))[element1.name]
                    //                        element1.parentNode.insertBefore(input1, element1.nextSibling)
                    //                    } else {
                    //                        element1.setAttribute('readonly', true)
                    //                    }
                    //                } else if (instance.formMode === 'ReadOnly') { element1.setAttribute('disabled', true) }
                    //            }
                    //        } else {
                    //            var element2 = document.getElementById(ID)
                    //            if (element2) {
                    //                if (instance.formMode === 'Update') {
                    //                    if (element2.nodeName === 'SELECT') {
                    //                        element2.setAttribute('disabled', true)
                    //                        var input2 = document.createElement('input')
                    //                        input2.name = element2.name
                    //                        input2.type = 'hidden'
                    //                        input2.value = JSON.parse(localStorage.getItem('data'))[element2.name]
                    //                        element2.parentNode.insertBefore(input2, element2.nextSibling)
                    //                    } else {
                    //                        element2.setAttribute('readonly', true)
                    //                    }
                    //                } else if (instance.formMode === 'ReadOnly') { element2.setAttribute('disabled', true) }
                    //            }
                    //        }
                    //        resolve()
                    //    })
                    //},
                    initializeData(model, isSearch) {
                        if (localStorage.getItem('data') !== null && !isSearch) {
                            try {
                                var data = JSON.parse(localStorage.getItem('data'))
                                for (var i = 0; i < model.formInputs; i++)
                                    model.formInputs[i].model = data[model.formInputs[i].name]
                                return model
                            } catch (exception) {
                                return model
                            }
                        } else {
                            return model
                        }
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/scripts/VueFormSetup.js